<app-resource-builder-alternative-form
    [formArray]="alternativeFormArray"
    [alternatives]="alternatives | async"
    [editable]="editable"
    [questionType]="questionType"
    [usePoints]="usePoints">
</app-resource-builder-alternative-form>
